import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import BASE_URL, { IMAGE_DOMAIN } from '../../../../config/config';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { isValidPhoneNumber } from 'libphonenumber-js';
import Loader from '../../../../components/Loader';

const DetalleUsuario = () => {
  const { usuario } = useParams();
  const [usuarioData, setUsuarioData] = useState(null);
  const [form, setForm] = useState({});
  const [cargando, setCargando] = useState(true);
  const [tabActiva, setTabActiva] = useState('informacion');

  const token = localStorage.getItem('AuthToken');

  useEffect(() => {
    const obtenerUsuario = async () => {
      try {
        if (!usuario) {
          toast.error('ID de usuario no proporcionado.');
          setCargando(false);
          return;
        }

        const peticionUsuario = axios.get(`${BASE_URL}/usuario/info/${usuario}`, {
          headers: { Authorization: token },
        });

        const esperaMinima = new Promise((resolve) => setTimeout(resolve, 500));

        const [resp] = await Promise.all([peticionUsuario, esperaMinima]);

        const datos = resp.data.usuarios || resp.data.usuario || resp.data;
        setUsuarioData(datos);
        setForm(datos);
      } catch (err) {
        console.error('Error al cargar usuario:', err);
        toast.error('No se pudo cargar el usuario.');
      } finally {
        setCargando(false);
      }
    };

    obtenerUsuario();
  }, [usuario, token]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const validarFormulario = () => {
    const errores = [];

    if (!form.nombre || form.nombre.trim() === '') errores.push('El nombre no puede estar vacío.');
    if (!form.apellidos || form.apellidos.trim() === '') errores.push('Los apellidos no pueden estar vacíos.');

    if (!form.email || !/\S+@\S+\.\S+/.test(form.email)) {
      errores.push('Email inválido.');
    }

    if (form.telefono && form.telefono.trim() !== '') {
      try {
        const esValido = isValidPhoneNumber(form.telefono, 'ES'); // Puedes cambiar el país base si no es España
        if (!esValido) errores.push('Teléfono inválido.');
      } catch (e) {
        errores.push('Formato de teléfono no reconocido.');
      }
    }

    return errores;
  };

  const noHayCambios = () => {
    const camposClave = [
      'nombre',
      'apellidos',
      'email',
      'telefono',
      'role',
      'estado',
      'servicios_holded',
      'webs_del_cliente',
      'dpto_tecnico'
    ];
    return camposClave.every((campo) => form[campo] === usuarioData[campo]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errores = validarFormulario();
    if (errores.length > 0) {
      toast.error(errores.join(' '));
      return;
    }

    if (noHayCambios()) {
      toast.warning('No has actualizado ningún dato.');
      return;
    }

    try {
      const resp = await axios.put(`${BASE_URL}/usuario/update/${usuario}`, form, {
        headers: { Authorization: token },
      });
      setUsuarioData(resp.data.user);
      toast.success('Datos actualizados correctamente.');
    } catch (err) {
      console.error('Error al actualizar:', err);
      toast.error('Hubo un error al guardar los cambios.');
    }
  };

  if (cargando) return <Loader />;
  if (!usuarioData) return <p>Usuario no encontrado.</p>;

  return (
    <main className="site-width">
      <ToastContainer position="bottom-right" autoClose={3000} />

      <div className="contenido-detalle-usuario"></div>

      <h2 className="titulo-seccion">
        Perfil de {usuarioData.nombre} {usuarioData.apellidos}
      </h2>

      <div className="grid-perfil-interno">
        <div className="detalles-esenciales">
          <h3>Estado de la cuenta</h3>
          <div>
            <p>
              Cuenta:{' '}
              {usuarioData.estado === 'suspendido' && (
                <span className="suspendida">Suspendida por cancelación de servicios o impago</span>
              )}
              {usuarioData.estado === 'verificar' && (
                <span className="sin-verificar">Pendiente de verificar</span>
              )}
              {usuarioData.estado === 'verificado' && (
                <span className="verificada">Verificada y con acceso</span>
              )}
            </p>

            <hr />
            <h3>Permisos</h3>
            <p>
              Rol:{' '}
              {usuarioData.role === 'admin' ? (
                <span className="es-administrador">Administrador</span>
              ) : (
                <span className="es-usuario">Usuario</span>
              )}
            </p>
            {usuarioData.role === 'admin' && (
              <p>
                Departamento:
                {usuarioData.dpto_tecnico === 'no_especificado' && ' No especificado'}
                {usuarioData.dpto_tecnico === 'desarrollo' && ' Desarrollo'}
                {usuarioData.dpto_tecnico === 'marketing' && ' Marketing'}
                {usuarioData.dpto_tecnico === 'diseno' && ' Diseño'}
                {usuarioData.dpto_tecnico === 'redes_sociales' && ' Redes Sociales'}
              </p>
            )}
            <hr />
            <h3>Información breve</h3>
            <p>
              Servicios Holded:{' '}
              {usuarioData.servicios_holded
                ? usuarioData.servicios_holded
                  .split(',')
                  .map((id, index) => (
                    <span className='dato' key={index}>
                      {id.trim()}
                      <br />
                    </span>
                  ))
                : 'N/A'}
            </p>
            <p>Webs: <span className='dato'>{usuarioData.webs_del_cliente || 'N/A'}</span></p>

            <hr />
            <p className="registro">
              <span>Usuario registrado el </span>
              {new Date(usuarioData.createdAt).toLocaleString('es-ES', {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
              })}
            </p>
          </div>
        </div>

        <div className="perfil-interno">
          <div className="cabecera-perfil-usuario">
            <img
              className="foto-perfil"
              src={usuarioData.fotoPerfil ? (usuarioData.fotoPerfil.startsWith('http') ? usuarioData.fotoPerfil : `${IMAGE_DOMAIN}${usuarioData.fotoPerfil}`) : `${IMAGE_DOMAIN}/images/default-user.png`}
              alt="Foto de perfil"
            />
            <div className="datos-perfil-interno">
              <h3>
                {usuarioData.nombre} {usuarioData.apellidos}
              </h3>
              <p className="nombre-usuario">@{usuarioData.usuario}</p>
            </div>
          </div>


          <div className="tarjeta-detalle-usuario">
            {/* Tabs */}
            <div className="tabs">
              <button
                className={tabActiva === 'informacion' ? 'tab activo' : 'tab'}
                onClick={() => setTabActiva('informacion')}
              >
                Información
              </button>
              <button
                className={tabActiva === 'ajustes' ? 'tab activo' : 'tab'}
                onClick={() => setTabActiva('ajustes')}
              >
                Ajustes avanzados
              </button>
            </div>

            <form className="form-detalle-usuario" onSubmit={handleSubmit}>
              <div className="info-usuario">
                {tabActiva === 'informacion' && (
                  <>
                    <label>
                      <span>Usuario</span>
                      <span className="advertencia-input">Solo modificable desde la base de datos.</span>
                      <input
                        type="text"
                        name="usuario"
                        value={'@' + usuarioData.usuario || ''}
                        disabled
                      />
                    </label>
                    <div className="grid-campos-detalles">
                      <label>
                        <span>Nombre</span>
                        <input
                          type="text"
                          name="nombre"
                          value={form.nombre || ''}
                          onChange={handleChange}
                        />
                      </label>

                      <label>
                        <span>Apellidos</span>
                        <input
                          type="text"
                          name="apellidos"
                          value={form.apellidos || ''}
                          onChange={handleChange}
                        />
                      </label>
                    </div>
                    <div className="grid-campos-detalles">
                      <label>
                        <span>Email</span>
                        <input
                          type="email"
                          name="email"
                          value={form.email || ''}
                          onChange={handleChange}
                        />
                      </label>

                      <label>
                        <span>Teléfono</span>
                        <input
                          type="text"
                          name="telefono"
                          value={form.telefono || ''}
                          onChange={handleChange}
                        />
                      </label>
                    </div>

                    <label>
                      <span>Webs asociadas</span>
                      <input
                        type="text"
                        name="webs_del_cliente"
                        value={form.webs_del_cliente || ''}
                        onChange={handleChange}
                      />
                    </label>
                  </>
                )}

                {tabActiva === 'ajustes' && (
                  <>
                    <label>
                      <span>Rol</span>
                      <select name="role" value={form.role || ''} onChange={handleChange}>
                        <option value="user">Usuario</option>
                        <option value="admin">Administrador</option>
                      </select>
                    </label>

                    {usuarioData.role === 'admin' && (
                      <label>
                        <span>Departamento técnico</span>
                        <span className="advertencia-input">Este campo solo es visible si el usuario es administrador.</span>
                        <select name="dpto_tecnico" value={form.dpto_tecnico || ''} onChange={handleChange}>
                          <option value="no_especificado">No especificado</option>
                          <option value="desarrollo">Desarrollo</option>
                          <option value="diseno">Diseño gráfico</option>
                          <option value="marketing">Marketing</option>
                          <option value="redes_sociales">Redes Sociales</option>
                        </select>
                      </label>
                    )}

                    <label>
                      <span>Estado</span>
                      <span className="advertencia-input">Los usuarios "Sin verificar", no tendrán acceso al soporte técnico.</span>
                      <select name="estado" value={form.estado || ''} onChange={handleChange}>
                        <option value="verificar">Sin verificar</option>
                        <option value="suspendido">Suspendido</option>
                        <option value="verificado">Verificado</option>
                      </select>
                    </label>

                    <label>
                      <span>ID(s) Holded</span>
                      <span className="advertencia-input">Si existen múltiples servicios (ID) del cliente, separalos con comas.</span>
                      <input
                        type="text"
                        name="servicios_holded"
                        value={form.servicios_holded === 'sin_servicios' ? '' : form.servicios_holded}
                        onChange={handleChange}
                      />
                    </label>
                  </>
                )}

                <button type="submit" className="btn-guardar">
                  Guardar cambios
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </main>
  );
};

export default DetalleUsuario;
